export default {
  title: {
    en: `Select what you'd like to try <br class="onlyDesktop" />from our best sellers`,
  },
}
